<template>
    <div class="m-portlet__foot m-portlet__foot--fit">
        <div class="m-form__actions">
            <button type="button" class="btn btn-primary" @click="save" v-if="!disableSave">
                {{$t('Save')}}
            </button>
            <button v-if="!disableCancel" type="button" class="btn btn-secondary" @click="goToList">
                {{$t('Cancel')}}
            </button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Buttons',
  props: {
    listLink: {
      type: String
    },
    disableCancel: {
      type: Boolean,
      default: false
    },
    disableSave: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    save () {
      this.$emit('save')
    },
    goToList: function () {
      this.$router.push(this.listLink)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/form/Buttons.vue